import { jsx as _jsx } from "react/jsx-runtime";
export function Skeleton({ className, ...props }) {
    return (_jsx("div", { className: `animate-pulse rounded-md bg-gray-200 ${className || ''}`, ...props }));
}
